import React from 'react';
import CustomModal from './index';
import PropTypes from 'prop-types';
import logo from '../../../assets/app/swiss-logo.png';

const ModalAdvice = ({
  title,
  close,
  children,
  icon = true,
  size = 'lg',
  customButtons = false,
  accept,
}) => {
  const buttons = [
    {
      title: 'Aceptar',
      className: 'btn btn-danger text-center',
      action: close,
    },
  ];

  const modalCustomButtons = [
    {
      title: 'Aceptar',
      className: 'btn btn-danger text-center',
      action: () => {
        accept();
        close();
      },
    },
    {
      title: 'Cancelar',
      className: 'btn btn-secondary text-center',
      action: close,
    },
  ];

  return (
    <CustomModal
      title={title}
      show={true}
      close={close}
      buttons={customButtons ? modalCustomButtons : buttons}
      size={size}
    >
      {icon && (
        <div className='d-flex justify-content-center pt-3'>
          <img style={{ width: 50, height: 50 }} src={logo} alt='swissmedical' />
        </div>
      )}
      <div className='d-flex justify-content-center p-4 text-center'>{children}</div>
    </CustomModal>
  );
};

ModalAdvice.proptypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default ModalAdvice;
